// Banda de políticas globales: ventana, clawback, tope del multiplicador y pagos. "Editar" abre el
// modal. Mockup: portal-admin-vl-comisiones.html
import type { RetailCommission } from '@fiado/type-kit';
import { CommissionBillingPeriodEnum } from '@fiado/type-kit/bin/retailCommission/enums/CommissionBillingPeriodEnum';
import { Button } from '@/kit';
import { BILLING_PERIOD_LABEL, factor, WINDOW_LABEL } from '../../lib/ruleText';

interface PoliciesBandProps {
    policies: RetailCommission.CommissionPolicies | undefined;
    isLoading: boolean;
    canEdit: boolean;
    onEdit: () => void;
}

export function PoliciesBand({ policies, isLoading, canEdit, onEdit }: PoliciesBandProps) {
    const clawback = policies?.clawback ?? null;
    const commissions = policies?.commissions ?? null;
    // Sin política de pagos guardada, el motor deposita a la wallet y cobra cada semana.
    const walletDeposits = policies?.payouts?.walletDeposits ?? true;
    const billing = policies?.payouts?.chainBillingPeriod ?? CommissionBillingPeriodEnum.WEEKLY;
    return (
        <div className="flex flex-none flex-wrap items-center gap-x-4 gap-y-1 border-b border-border bg-muted/40 px-5 py-2 text-[11px]">
            <span className="text-[10px] font-bold uppercase tracking-[0.08em] text-muted-foreground">
                Políticas globales
            </span>
            {isLoading ? (
                <span className="text-muted-foreground">Cargando…</span>
            ) : (
                <>
                    <span>
                        Ventana:{' '}
                        <b>{commissions ? WINDOW_LABEL[commissions.ventanaDefault] : '—'}</b>
                    </span>
                    <span>
                        Clawback:{' '}
                        {clawback ? (
                            <>
                                Canc. <b>{clawback.cancelacionDias}d</b> · Dev.{' '}
                                <b>{clawback.devolucionDias}d</b> · NPI M30{' '}
                                <b>{clawback.npiM30Dias}d</b>
                            </>
                        ) : (
                            <b>—</b>
                        )}
                    </span>
                    <span>
                        Mult. cap:{' '}
                        <b>{commissions ? factor(commissions.multiplicadorMaxBps) : '—'}</b>
                    </span>
                    <span>
                        Pagos:{' '}
                        {policies ? (
                            <>
                                <b>{walletDeposits ? 'a la wallet' : 'pausados'}</b> · cobro{' '}
                                <b>{BILLING_PERIOD_LABEL[billing].toLowerCase()}</b>
                            </>
                        ) : (
                            <b>—</b>
                        )}
                    </span>
                    {!clawback && !commissions && (
                        <span className="text-warning">Sin políticas guardadas</span>
                    )}
                </>
            )}
            <span className="ml-auto italic text-muted-foreground">aplican a todas las reglas</span>
            {canEdit && (
                <Button size="sm" variant="outline" disabled={!policies} onClick={onEdit}>
                    Editar
                </Button>
            )}
        </div>
    );
}
